import { Link } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';
import { Instagram, Youtube, Music, Headphones } from 'lucide-react';


const socialLinks = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/zateviss/" },
  { icon: Headphones, label: "Spotify", href: "https://open.spotify.com/intl-tr/artist/5VnhzFb2I1U9qLmLbj6fhZ" },
];

const footerNav = [
  { path: '/', key: 'nav_home' },
  { path: '/requests', key: 'nav_requests' },
  { path: '/beats', key: 'nav_beats' },
  { path: '/izbirak', key: 'nav_izbirak' },
  { path: '/portfolio', key: 'nav_portfolio' },
  { path: '/about', key: 'nav_about' },
  { path: '/contact', key: 'nav_contact' },
];

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="relative overflow-hidden border-t border-white/[0.04]" data-testid="main-footer">
      {/* Giant Background Text */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden"
        aria-hidden="true"
      >
        <span
          className="
    font-syne
    font-extrabold
    block
    w-full
    leading-none
    text-white/[0.017]
    whitespace-nowrap
    tracking-tighter
    text-[13vw]
    max-w-full
  "
        >
          ZATEVISS
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Zateviss" className="w-8 h-full rounded-full" />
              <span className="font-syne font-bold text-base tracking-tight">Zateviss</span>
            </div>
            <p className="text-sm text-white/30 max-w-xs leading-relaxed">
              Not the way a <span className="text-white/70">human </span>does.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/20 mb-5">
              {t('footer_nav')}
            </h4>
            <nav className="flex flex-col gap-2.5" data-testid="footer-nav">
              {footerNav.map(link => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.key}`}
                  className="text-sm text-white/30 hover:text-white/70 transition-colors duration-200"
                >
                  {t(link.key)}
                </Link>
              ))}
            </nav>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/20 mb-5">
              {t('footer_connect')}
            </h4>
            <div className="flex gap-2.5 mb-5">
              {socialLinks.map(social => (
                <a
                  key={social.label}
                  href={social.href}
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                  className="p-2.5 rounded-full bg-white/[0.03] hover:bg-white/[0.08] transition-colors duration-200"
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <social.icon className="w-4 h-4 text-white/40" />
                </a>
              ))}
            </div>
            <a
              href="mailto:contact@zateviss.com"
              data-testid="footer-email"
              className="text-sm text-white/30 hover:text-[#00E5FF] transition-colors duration-200"
            >
              contact@zateviss.com
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/[0.04] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/15">
            &copy; {new Date().getFullYear()} Zateviss. {t('footer_rights')}
          </p>
          <div className="h-[1px] w-12 bg-gradient-to-r from-[#7F00FF]/50 to-[#00E5FF]/50" />
        </div>
      </div>
    </footer>
  );
}
